var exports = {
  "s": "HideWhenNarrow__nfGOuR",
};

module.exports = exports;
